import type { IPaginationAndSearchParams } from "@/shared/api/search-params"
import type { IQuarterNumber } from "@/shared/types/interfaces"

export interface ISaveEnergyPassportParams {
  contractId: string | number
  year: string | number
}

export type IFetchEnergyPassportParams = ISaveEnergyPassportParams & IPaginationAndSearchParams

export interface IEnergyPassportProductFrontSpecific {
  tempId?: string
  nameError: boolean
}

export interface IEnergyPassportProduct extends IEnergyPassportProductFrontSpecific {
  id?: number
  quarter_number: IQuarterNumber
  product_name: string
  count: number
  count_measure: string
  active_energy: number
  reactive_energy: number
  thermal_energy: number
  gas: number
  mazut: number
  coal: number
  gasoline: number
  diesel: number
  kerosene: number
  // oils: number
  other_petroleum_products: number
  water: number
  is_main_product: boolean
}

export interface IEnergyPassportPayload {
  products: IEnergyPassportProduct[]
  deleted_products: number[]
  details: IEnergyPassportDetails[]
}

interface IEnergyPassportQuarterTotal {
  count: number
  thermal_energy: number
  gas: number
  mazut: number
  coal: number
  gasoline: number
  diesel: number
  kerosene: number
  oils: number
  other_petroleum_products: number
  water: number
  active_energy: number
  reactive_energy: number
  product_count: number
}

interface IEnergyPassportQuarterData {
  id: number
  quarter_number: number
  created_at: string
  updated_at: string
  product_count: number
  total: IEnergyPassportQuarterTotal
  products: IEnergyPassportProduct[]
}

export enum IEnergyPassportResourceType {
  ACTIVE_ELECTRICITY = "active_electricity",
  REACTIVE_ELECTRICITY = "reactive_electricity",
  HEAT = "heat",
  GAS = "gas",
  MAZUT = "mazut",
  COAL = "coal",
  PETROL = "petrol",
  DIESEL = "diesel",
  KEROSENE = "kerosene",
  LUBRICANT = "lubricant",
  OTHER_OIL_PRODUCT = "other_oil_product",
  WATER = "water"
}

export interface IEnergyPassportDetailsFrontSpecific {
  tempId?: string
}

export interface IEnergyPassportDetails extends IEnergyPassportDetailsFrontSpecific {
  id?: string
  created_at?: string
  updated_at?: string
  quarter: IQuarterNumber
  energy_type: IEnergyPassportResourceType
  declared_consumption?: number
  sub_consumption: number
  total_consumption: number
  technical_needs: number
  own_needs: number
  production_needs: number
  residential_needs: number
  consumption_standard: number
  max_nominal_capacity_per_hour?: number
  passport?: number
}

export interface IEnergyPassportDataDetails {
  quarters: IEnergyPassportDetails[]
  totals: Omit<IEnergyPassportDetails, "tempId" | "passport" | "created_at" | "updated_at" | "quarter">
}

export interface IEnergyPassportData {
  id: number
  year: number
  quarters: IEnergyPassportQuarterData[]
  details: IEnergyPassportDataDetails
  created_at: string
  updated_at: string
}
